














import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import DashboardChart from '../add-on/DashboardChart.vue';
import DashboardService from '../../../services/dashboard.service';

@Component({
  name: 'DashboardDeliveryConsultGraph',
  components: {
    DashboardChart,
  },
})
export default class DashboardDeliveryConsultGraph extends BaseComponent {
  private founderConsultGraph = null;
  private options = null;

  getGraph() {
    DashboardService.dashboardConsultGraph().subscribe(res => {
      this.options = { responsive: true, maintainAspectRatio: false };
      this.founderConsultGraph = res.data;
    });
  }

  async mounted() {
    this.getGraph();
  }
}
